import { AxiosError } from 'axios';
import { Nullable } from 'utils/types';
import { State as OriginalState } from '../core/types';
import { Cases } from '../../api/casesListing/types';
import { ValidationError as PepperValidationError } from 'modules/cm/pages/CaseDetailsPage/Pepper/errors/PepperValidationError';

export type State = OriginalState<Cases, Nullable<AxiosError>, Nullable<PepperValidationError>>;
export type Action = {
  type: ActionType;
  payload: [Nullable<Cases>, Nullable<AxiosError>];
};

export type ActionType = ACTION_TYPES.ERROR | ACTION_TYPES.PENDING | ACTION_TYPES.SUCCESS;

export enum ACTION_TYPES {
  SUCCESS = 'CM/CASES/SUCCESS',
  ERROR = 'CM/CASES/ERROR',
  PENDING = 'CM/CASES/PENDING',
}
